import { CreditCardPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/CreditCard/_shared/entities/PaymentMethodDetail/CreditCardPaymentMethodDetailEntity';
import { useIberiaCardParams } from '@/components/modules/CreditCard/Detail/Overview/hooks/useIberiaCardParams';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { CreditCardConfigurationType } from '@/config/types';

interface ConditionsProps {
  paymentMethodDetailEntity: CreditCardPaymentMethodDetailEntity;
}

export const Conditions = ({ paymentMethodDetailEntity }: ConditionsProps) => {
  const { getTextIdTranslation } = useTranslation();
  const { getIberiaCardParams } = useIberiaCardParams();

  const creditCardConfiguration = paymentMethodDetailEntity?.configuration as CreditCardConfigurationType;

  if (!creditCardConfiguration) {
    return null;
  }

  const cardParams = getIberiaCardParams(creditCardConfiguration.card.type);

  return (
    <FlexRow position="relative" alignItems="space-between" paddingBottom={3}>
      <Font variant="h2" color="title" style={{ wordBreak: 'break-all' }}>
        {`${getTextIdTranslation('CARD')} ${
          cardParams ? `${getTextIdTranslation(cardParams.name)}` : creditCardConfiguration.card.type
        }`}
      </Font>
      <FlexRow justifyContent="flex-start" gridGap={4}>
        <img
          src={'https://cdn.nemuru.com/assets/logos/iberia-cards-logo.svg'} // TODO: change to the correct logo (only wing) (NEMURU-3484)
          alt={'Iberia Cards Logo'}
          style={{ height: '24px' }}
        />
      </FlexRow>
    </FlexRow>
  );
};
